document.addEventListener('DOMContentLoaded', () => {
  const options = { threshold: 0.1 };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;

        // Skip .slide elements — they are handled by animateChildren
        if (el.classList.contains('slide')) {
          obs.unobserve(el);
          return;
        }

        const animationMode = el.getAttribute('data-animations');

        if (animationMode) {
          animateChildren(el, animationMode);
        } else {
          const anim = el.dataset.animation;
          if (anim && anim !== 'none') {
            el.classList.add(anim);
            el.setAttribute('data-animated', 'true');
          }
        }

        obs.unobserve(el);
      }
    });
  }, options);

  // Only observe .data-animation elements that are NOT .slide
  document.querySelectorAll('[data-animation]:not(.slide), [data-animations]').forEach(el => {
    observer.observe(el);
  });
});

function animateChildren(container, mode) {
  const children = Array.from(container.children);
  let currentIndex = 0;
  let isHovered = false;

  if (container.getAttribute('data-hover') === 'true') {
    container.addEventListener('mouseenter', () => isHovered = true);
    container.addEventListener('mouseleave', () => isHovered = false);
  }

  children.forEach(child => {
    child.style.position = 'absolute';
    child.style.opacity = '0';
    child.style.display = 'block';
  });

  function showChild(index) {
    const child = children[index];
    if (!child) return;

    const anim = child.dataset.animation;
    const duration = parseFloat(child.dataset.duration || '2') * 1000;
    const pause = parseFloat(child.dataset.pause || '0') * 1000;

    children.forEach((c, i) => {
      const cAnim = c.dataset.animation;
      const shouldAnimate = cAnim && cAnim !== 'none';

      if (i === index) {
        c.style.opacity = '1';
        c.classList.add('active');
        c.setAttribute('data-animated', 'true');
        if (shouldAnimate) {
          c.classList.add(cAnim);
        }
      } else {
        c.style.opacity = '0';
        c.classList.remove('active');
        c.removeAttribute('data-animated');
        if (shouldAnimate) {
          c.classList.remove(cAnim);
        }
      }
    });

    const totalWait = duration + pause;

    const waitForNext = () => {
      setTimeout(() => {
        if (isHovered) {
          waitForNext(); // retry while hovered
          return;
        }

        if (mode === 'end') {
          currentIndex++;
          if (currentIndex < children.length) showChild(currentIndex);
        } else if (mode === 'loop') {
          currentIndex = (currentIndex + 1) % children.length;
          showChild(currentIndex);
        } else if (mode === 'shuffle') {
          let nextIndex;
          do {
            nextIndex = Math.floor(Math.random() * children.length);
          } while (nextIndex === currentIndex && children.length > 1);
          currentIndex = nextIndex;
          showChild(currentIndex);
        }
      }, totalWait);
    };

    waitForNext();
  }


  showChild(currentIndex);
}
